module.exports = require("core-js-pure/stable/object/define-properties");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/object/define-properties.js
// module id = 2859
// module chunks = 25